import { PaymentEventDetailList } from '@domains/pdp-common';

export function findMaxDiscountAmount(eventDetailList: PaymentEventDetailList[]) {
  return eventDetailList.reduce((acc, cur) => {
    const hasHigherDiscount = cur.discount_amount > acc;
    return hasHigherDiscount ? cur.discount_amount : acc;
  }, 0);
}
